<template>
  <Loader :value="promises.fetch">
    <div class="residential-page">
      <Blocks :blocks="config" :custom-components="customComponents" />
    </div>
  </Loader>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ResidentialComponents from '@/components/Residential'
import CustomComponents from '@/components/Custom'
import Config from '../config/residential'
import { Blocks } from '@kvass/pagebuilder'

import { animate, inView } from 'motion'
import BrowserApiMixin from '@/mixins/browser-api'

export default {
  mixins: [BrowserApiMixin('residential')],
  props: {
    id: String,
  },
  watch: {
    id: {
      handler(val) {
        return this.fetch(val).then(data => {
          if (!data) return this.$router.push({ name: 'notfound' })
        })
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState('Residential', ['promises', 'item']),
    config() {
      return Config.call(this)
    },
    customComponents() {
      return {
        ...CustomComponents,
        ...ResidentialComponents,
      }
    },
  },
  methods: {
    ...mapActions('Residential', ['fetch']),
    async initAnimation() {
      inView('.kvass-image-text__item', ({ target }) => {
        animate(target, { opacity: 1, transform: 'none' }, { duration: 0.8 })
      })
    },
  },
  metaInfo() {
    return {
      title: this.item.name || `${this.$t('loading', { resource: null })}...`,
    }
  },
  mounted() {
    this.promises.fetch.then(() => this.$nextTick(() => this.initAnimation()))
  },
  components: {
    ...ResidentialComponents,
    Blocks,
  },
}
</script>

<style lang="scss">
.residential-page {
  min-height: 100vh;
  & > .kpb-blocks {
    @for $i from 1 through 15 {
      & > *:nth-child(#{$i}) {
        order: $i * 10;
      }
    }
  }

  .kvass-image-text__item {
    opacity: 0;
  }

  .section-floorplan {
    .kpb-gallery__item-caption {
      color: white;
    }
  }
  .residential__floorplan {
    display: grid;
    grid-template-columns: repeat(3, 1fr) !important;

    .kpb-gallery__item:nth-child(1) {
      grid-column-end: span 3;
      max-height: 800px;
    }
  }

  .section-residentials {
    .kpb-section__container {
      @include respond-below('phone') {
        padding: 0;
      }
    }
  }
}
</style>
